import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LinkRoutingModule } from './link-routing.module';
import { FormComponent } from './form/form.component';

@NgModule({
  declarations: [FormComponent],
  imports: [
    CommonModule,
    LinkRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class LinkModule { }